import { HeadCell, OptionItem, STATUSES } from 'models';
import { PUBLIC_HOLIDAY_ITEM_TYPE } from 'models/public-holiday';

export const headCells: readonly HeadCell<PUBLIC_HOLIDAY_ITEM_TYPE>[] = [
  {
    id: 'name',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Public Holiday Name',
  },
  {
    id: 'date',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Date',
  },
  {
    id: 'year',
    numeric: false,
    disablePadding: true,
    isSort: false,
    label: 'Year',
  },
  {
    id: 'createdAt',
    numeric: false,
    disablePadding: false,
    isSort: false,
    label: 'Created Date',
  },
  {
    id: 'is_active',
    numeric: false,
    disablePadding: false,
    isSort: true,
    label: 'Status',
  },
];

export const PUBLIC_HOLIDAY_STATUSES: OptionItem[] = [
  {
    id: STATUSES.ACTIVE,
    name: 'Active',
  },
  {
    id: STATUSES.INACTIVE,
    name: 'Inactive',
  },
];
